// @flow

/**
 * Module dependencies.
 */

import { Col, Row } from 'client/components/core/grid';
import { branch } from 'core/utils';
import { colors, units } from 'client/styles';
import Layout from 'client/components/core/layout';
import RawHtml from 'react-raw-html';
import React from 'react';
import Text from 'client/components/core/type';

/**
 * `Item` type.
 */

type Item = {
  text: string,
  title: string
};

/**
 * `Props` type.
 */

type Props = {
  items: Array<Item>,
  lead?: string,
  title: string
};

/**
 * Render text items.
 */

function renderTextItems(items) {
  const lastIndex = items.length - 1;
  const lastItemMargin = (index: number): string => {
    return index !== lastIndex ? units(7) : units(0);
  };

  return items.map(({ text, title }: Item, index: number) => (
    <Layout
      key={title}
      marginBottom={lastItemMargin(index)}
    >
      <Text.H3
        color={colors.brandPrimary}
        marginBottom={units(2)}
      >
        {title}
      </Text.H3>

      <Text.Paragraph>
        <RawHtml.span>
          {text}
        </RawHtml.span>
      </Text.Paragraph>
    </Layout>
  ));
}

/**
 * `StaticSections` component.
 */

function StaticSections(props: Props): React$Element<*> {
  const { items, lead, title } = props;

  return (
    <Row>
      <Col
        md={2}
        xs={10}
        xsOffset={1}
      >
        <Layout
          marginBottomMd={units(0)}
          marginBottomSm={units(8)}
        >
          <Text.H2 color={colors.brandPrimary}>
            {title}
          </Text.H2>
        </Layout>
      </Col>

      <Col
        md={6}
        xs={10}
        xsOffset={1}
      >
        <Layout paddingTopMd={units(1)}>
          <Row>
            <Col
              lg={10}
              xs={12}
            >
              {branch(lead, () => (
                <Layout
                  key={title}
                  marginBottom={units(7)}
                >
                  <Text.Paragraph>
                    <RawHtml.span>
                      {lead}
                    </RawHtml.span>
                  </Text.Paragraph>
                </Layout>
              ))}

              {renderTextItems(items)}
            </Col>
          </Row>
        </Layout>
      </Col>
    </Row>
  );
}

/**
 * Export `StaticSections` component.
 */

export default StaticSections;



// WEBPACK FOOTER //
// ../src/client/components/static-sections/index.js